import axiosInstance from "@/api/axios-instance";

export interface VerifyUsageIdResult {
  success: boolean;
  message: string;
  // Present only when the pack exists (added for the Decorator Links builder).
  usage?: {
    id: string;
    status: string;
    bundle_name: string | null;
    product_id: string | null;
    product_name: string | null;
    users: { id: string; full_name: string }[];
    managed_event_ids: string[];
  };
}

export async function verifyUsageId(
  usage_id: string,
): Promise<VerifyUsageIdResult> {
  const response = await axiosInstance.post("/usage/verify-usage-id", { usage_id });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Usage ID verification failed");
  }

  return response.data;
}